// CANONICAL COPY (GH #7115). src/constants/obligations/obl-network-security-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-network-security-review',
  title: 'Review network security architecture',
  description:
    'Review network architecture documentation. Verify segmentation, firewall rules, secure management protocols, and service-level security for all network services are in place.',
  category: 'technical',
  scfIds: ['SCF-NET-001', 'SCF-NET-002', 'SCF-NET-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Network architecture documentation is published' },
    { type: 'document-within-sla', description: 'Documentation review is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
